export const OG_DESCRIPTION_MAX_LENGTH = 300;
